import { ReactNode } from "react";
import useDebugFeature from "./useDebugFeature";
import { DebugQueryParameterName } from "../../types/debug";

/**
 * Render some debug features that are hidden by default.
 *
 * If queryParameterName is "debugSomething", and the page is loaded with ?debugSomething in the
 * query parameters, this fact gets saved to localStorage, and the debug feature will start showing
 * up permanently.
 * If closePermanently() is called, the debug feature gets hidden permanently again.
 *
 * @param renderFunction
 * @param queryParameterName
 * @constructor
 */
export default function DebugFeature({
  renderFunction,
  queryParameterName,
}: Props) {
  const enabledDebugFeature = useDebugFeature({ queryParameterName });

  return enabledDebugFeature ? renderFunction(enabledDebugFeature) : null;
}

type Props = {
  queryParameterName: DebugQueryParameterName;
  renderFunction: (props: {
    bugIcon: ReactNode;
    closeIcon: ReactNode;
    closePermanently: () => void;
  }) => ReactNode;
};

export function BugIcon(props: { queryParameterName: string }) {
  return (
    <span
      title={`This is visible, because ?${props.queryParameterName} was set.`}
    >
      🐞
    </span>
  );
}
